import { useContext } from 'react'
import { CompanyContext } from './CompanyContext'
import type { CompanyState } from './CompanyContext'

export function useCompanies(): CompanyState {
  const context = useContext(CompanyContext)
  if (!context) throw new Error('useCompanies must be used inside <CompanyProvider>')
  return context
}
